export const protocol_set = {
  Download_complete_and_detailed_mapping_file: "Télécharger le fichier de mappage complet et détaillé",
  Download_complete_and_simplified_mapping_file: "Télécharger le fichier de mappage complet et simplifié",
  Download_filtered_and_simplified_mapping_file: "Télécharger le fichier de mappage filtré et simplifié",
  Draft_Name: "Nom du brouillon",
  protocol_question: {
    Are_you_sure_you_want_to_delete_this_protocol_question:
      "Êtes-vous sûr de vouloir supprimer cette question de protocole ?",
    are_you_sure_you_want_to_duplicate_this_protocol_question:
      "Êtes-vous sûr de vouloir dupliquer cette question de protocole ?",
    Basic_information: "Informations de base",
    changed: "modifié",
    Content: "Contenu",
    Content_is_required: "Le contenu est requis",
    Create_protocol_question: "Créer une nouvelle question de protocole",
    created: "créé",
    deleted: "supprimé",
    erm_mapping_note: "Note de mappage ERM",
    Export_to_file: "Exporter vers un fichier",
    Internal_audit: "Audit interne",
    Link_a_requirement: "Lier une exigence",
    link_a_protocol_question: "Lier une question de protocole",
    link_protocol_questions: {
      Back_to_Linking_Page: "Retour à la page de liaison",
      Back_to_the_Protocol_Questions_List: "Retour à la liste des questions de protocole",
      Back_to_the_Requirements_List: "Retour à la liste des exigences",
      Link_protocol_questions_to_requirements: "Lier les questions de protocole à une exigence",
      Requirement_info: "Exigence",
      This_requirement_is_already_mapped_to: "Cette exigence est déjà mappée à :",
    },
    link_requirements: {
      Is_mapped: "Est mappé",
      Link: "Lier",
      Name_of_the_standard: "Nom du standard",
      Protocol_question_is_in_edit_mode:
        "La question de protocole est en mode édition, les modifications ne seront pas sauvegardées.",
      Search_results: "Résultats de recherche",
      Search_similarities_in_protocol_questions: "Rechercher des similitudes dans les questions de protocole",
      Select_filters: "Sélectionner les filtres",
      Smart_search_mode: "Mode de recherche intelligente",
      You_have_to_select_at_least_one_requirement: "Vous devez sélectionner au moins une exigence",
    },
    internal_note: "Note interne SME",
    Link_requirements: "Lier les exigences",
    linked: "lié",
    List_of_mapped_requirements: "Liste des exigences mappées",
    list_of_related_protocol_questions: "Liste des questions de protocole connexes",
    Protocol_question: "Question de protocole",
    Protocol_question_info: "Informations sur la question de protocole",
    Protocol_question_list: "Liste des questions de protocole",
    reorder: {
      No_protocol_questions_found_for_this_theme_and_subtheme:
        "Aucune question de protocole trouvée pour ce thème et sous-thème.",
      Reorder: "Réorganiser",
      Reorder_protocol_questions: "Réorganiser les questions de protocole",
      You_need_to_select_a_theme_and_subtheme:
        "Vous devez sélectionner un thème et un sous-thème pour réorganiser les questions de protocole.",
      You_want_to_proceed_without_saving_changes:
        "Vous voulez procéder sans sauvegarder ? Toutes les modifications seront perdues.",
    },
    Requirement_will_be_unlinked_from_the_protocol_question: "L'exigence sera dissociée de la question de protocole.",
    protocol_questions_will_be_unlinked: "Les questions de protocole seront dissociées",
    Save_protocol_question: "Enregistrer la question de protocole",
    Scope_of_applicability: "Portée d'applicabilité",
    Scope_of_applicability_is_required: "La portée d'applicabilité est requise",
    split: "diviser",
    Stakeholder_engagement: "Engagement des parties prenantes",
    Standard_structure: "Structure du standard",
    Start_a_new_draft: "Commencer un nouveau brouillon",
    Sub_theme_is_required: "Le sous-thème est requis",
    Subtheme: "Sous-thème",
    Theme: "Thème",
    Theme_is_required: "Le thème est requis",
    This_action_cannot_be_undone: "Cette action ne peut pas être annulée",
    This_file_will_contain_all_protocol_questions_in_this_mapping_set:
      "Ce fichier contiendra toutes les questions de protocole de cet ensemble de mappage.",
    This_file_will_contain_protocol_questions_based_on_all_the_customizations_and_filters_you_have_applied:
      "Ce fichier contiendra les questions de protocole basées sur toutes les personnalisations et filtres que vous avez appliqués.",
    This_mapping_draft_is_currently_in_review:
      "Ce brouillon de mappage est actuellement en révision. Effectuer cette modification annulera le statut de révision du brouillon.",
    This_protocol_question_is_also_linked_to: "Cette question de protocole est également liée à",
    Unlink: "Dissocier",
    unlinked: "dissocié",
    You_will_be_redirected_to_the_newly_created_protocol_question:
      "Vous serez redirigé vers la question de protocole nouvellement créée.",
  },
  Protocol_Question: "Question de protocole",
  Protocol_questions: "Questions de protocole",
  Protocol_set: "Ensemble de protocoles",
  question_id: "ID de la question",
  related_requirements: "Exigences connexes",
  review_draft: {
    Approve_and_close: "Approuver et fermer",
    Are_you_sure_you_want_to_publish_this_draft: "Êtes-vous sûr de vouloir publier ce brouillon ?",
    at: "à",
    Created_by: "Créé par",
    Download_draft_changes: "Télécharger les modifications du brouillon",
    Draft_cannot_be_published_by_the_same_user:
      "Le brouillon ne peut pas être publié par le même utilisateur qui l'a soumis pour révision.",
    Draft_has_already_been_submitted: "Le brouillon a déjà été soumis pour approbation.",
    Draft_needs_to_be_submitted_for_review_before_publishing:
      "Le brouillon doit être soumis pour révision avant publication.",
    Draft_review: "Révision du brouillon",
    No_further_edits_will_be_possible_after_publishing:
      "Aucune modification supplémentaire ne sera possible après publication.",
    on: "le",
    page_description: {
      Note: "Note : Pendant l'état d'approbation en attente, tout changement supplémentaire à une question de protocole dans le brouillon rétablira l'état d'approbation en attente.",
      Please_press_download_draft:
        'Veuillez appuyer sur "Télécharger les modifications du brouillon" pour obtenir une représentation Excel des modifications de mappage de protocole entre ce brouillon et la dernière version publiée.',
      The_flow_for_mapping:
        "Le flux pour les modifications de mappage est le suivant : Brouillon -> Approbation en attente -> Publier.",
      This_is_the_page_for_draft:
        "Ceci est la page pour la révision et l'approbation des brouillons. Une fois approuvé par un autre utilisateur de l'outil de mappage, le brouillon sera publié le rendant sauvegardé sans autres modifications possibles.",
    },
    Published_by: "Publié par",
    Review_a_draft: "Réviser un brouillon",
    Submit_for_approval: "Soumettre pour approbation",
    Submitted_by: "Soumis par",
  },
  scope_of_applicability: "Portée d'applicabilité",
  Search_protocol_questions: "Rechercher des questions de protocole",
  Search_requirements: "Rechercher des exigences",
  Search_standards: "Rechercher des standards",
  standards: {
    Add_New_Standard: "Ajouter un nouveau standard",
    All_Clients: "Tous les clients",
    Back_to_the_Standards_List: "Retour à la liste des standards",
    Body: "Organisme",
    Create_New_Standard: "Créer un nouveau standard",
    Date: "Date",
    Edit_Standard: "Modifier le standard",
    Full_name: "Nom complet",
    ID: "ID",
    Link: "Lien",
    Publish_date: "Date de publication",
    Save_Standard: "Enregistrer le standard",
    Standard_body: "Organisme de normalisation",
    Standard_ID: "ID du standard",
    Tenants: "Locataires",
    Version: "Version",
  },
  Start_a_draft: "Commencer un brouillon",
  Start_draft_description: "Commencer un nouveau brouillon et passer en mode édition",
  Starting_new_draft_process: "Démarrage du processus de nouveau brouillon",
  sub_theme: "Sous-thème",
  theme: "Thème",
} as const;
